<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          plain
          :loading="exportLoading"
          @click="handleExport"
        >
          导出
        </el-button>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="损耗/更换详情"
      :visible.sync="detailVisible"
      width="900px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-descriptions :column="2" border size="small" class="deduction-detail-desc">
        <el-descriptions-item label="扣减单号">{{ detailForm.deductionNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ deductionTypeLabel(detailForm.deductionType) }}</el-descriptions-item>
        <el-descriptions-item label="总数量">{{ detailForm.totalQuantity || 0 }}</el-descriptions-item>
        <el-descriptions-item label="用途说明">{{ detailForm.purposeDesc || '-' }}</el-descriptions-item>
        <el-descriptions-item label="录入人">{{ detailForm.createName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="录入时间">{{ detailForm.createTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detailForm.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div class="detail-section-title">储备点扣减明细</div>
      <el-table :data="formatExtList(detailForm)" border size="small" empty-text="暂无扣减明细">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="materialCode" label="物资编码" min-width="130" show-overflow-tooltip />
        <el-table-column prop="materialName" label="物资名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="materialType" label="物资类型" width="110" show-overflow-tooltip />
        <el-table-column prop="storagePointName" label="储备点" min-width="150" show-overflow-tooltip />
        <el-table-column prop="currentStock" label="扣减前库存" width="110" align="right" />
        <el-table-column prop="deductionQuantity" label="扣减数量" width="110" align="right" />
        <el-table-column prop="unit" label="单位" width="80" align="center" />
        <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      </el-table>
      <span slot="footer">
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, exportExcel } from "./api";
import { getSearchTimeConfig } from "@/basic-common/util/common";
import { downloadXls } from "@/util/util";

export default {
  mixins: [crudMixins],
  data() {
    return {
      form: {},
      detailVisible: false,
      detailForm: {},
      exportLoading: false,
      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        selection: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        column: [
          {
            label: "扣减单号",
            prop: "deductionNo",
            overHidden: true,
            minWidth: 150,
            search: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "扣减总数",
            prop: "totalQuantity",
            type: "number",
            precision: 0,
            overHidden: true,
            width: 120,
            search: true,
          },
          {
            label: "类型",
            prop: "deductionType",
            search: true,
            overHidden: true,
            width: 100,
            type: "select",
            dicData: [
              { label: "损耗", value: 0 },
              { label: "更换", value: 1 },
            ],
          },
          {
            label: "用途说明",
            prop: "purposeDesc",
            overHidden: true,
            minWidth: 150,
            maxlength: 200,
            search: true,
          },
          {
            label: "关联申请单号",
            prop: "applicationNo",
            overHidden: true,
            minWidth: 150,
            search: true,
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            search: true,
            overHidden: true,
            width: 100,
            dicData: [
              { label: "无效", value: 0 },
              { label: "有效", value: 1 },
            ],
            value: 1,
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            maxlength: 500,
            span: 24,
            minRows: 3,
            hide: true,
          },
          {
            label: "录入人",
            prop: "createName",
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: "录入时间",
            prop: "createTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig("录入时间", { type: "datetimerange" }),
            paramsKey: ["startTime", "endTime"],
          },
          {
            label: "修改人",
            prop: "updateName",
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: "修改时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
        ],
      },
      defaultParams: {},
    };
  },
  methods: {
    formatExtList(row) {
      return (row && row.materialDeductionExtList) || [];
    },
    deductionTypeLabel(value) {
      const item = [{ label: "损耗", value: 0 }, { label: "更换", value: 1 }].find(item => String(item.value) === String(value));
      return item ? item.label : '-';
    },
    async openDetail(row) {
      try {
        const res = await getDetail(row.id);
        this.detailForm = (res.data && res.data.data) || {};
        this.detailVisible = true;
      } catch (error) {
        this.$message.error((error.response && error.response.data && error.response.data.msg) || '详情加载失败');
      }
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `损耗更换记录_${Date.now()}.xlsx`);
        this.$message.success("导出成功");
      } catch (e) {
        this.$message.error((e && e.message) || "导出失败");
      } finally {
        this.exportLoading = false;
      }
    },
    // 扩展beforeOpen，处理详情获取
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then(res => {
          this.form = res.data.data || res.data;
          done();
        });
      } else {
        done();
      }
    },
    // 扩展rowSave，处理新增
    rowSave(row, done, loading) {
      if (row.status === undefined || row.status === null) {
        row.status = 1;
      }
      this.apiConfig.add(row).then(() => {
        this.selectionClear();
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        done();
      }, () => {
        loading();
      });
    },
    // 扩展rowUpdate，处理更新
    rowUpdate(row, index, done, loading) {
      this.apiConfig.update(row).then(() => {
        this.selectionClear();
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        done();
      }, () => {
        loading();
      });
    },
  },
};
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
</style>
